import { Searcher } from 'fast-fuzzy';

const ABBREVIATIONS = {
	France: { av: 'avenue', ave: 'avenue', bd: 'boulevard', bvd: 'boulevard', r: 'rue', imp: 'impasse', all: 'allee', chem: 'chemin', pl: 'place', rte: 'route', st: 'saint', ste: 'sainte', sq: 'square' },
	England: { st: 'street', rd: 'road', ave: 'avenue', av: 'avenue', ln: 'lane', dr: 'drive', ct: 'court', blvd: 'boulevard', sq: 'square' },
	Spain: { c: 'calle', cl: 'calle', av: 'avenida', avda: 'avenida', pza: 'plaza', pl: 'plaza', ctra: 'carretera', pso: 'paseo', ps: 'paseo' },
	Portugal: { r: 'rua', av: 'avenida', pc: 'praca', tv: 'travessa', est: 'estrada', lg: 'largo' },
	Germany: { str: 'strasse', pl: 'platz', w:'Weg' },
	Netherlands: { str: 'straat', ln: 'laan', pl: 'plein' },
};

const strip = (value, country) => {
	const abbreviations = ABBREVIATIONS[country] ?? {};
	return String(value ?? '')
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
		.replace(/ß/g, 'ss')
		.replace(/[^\p{L}\p{N}\s]/gu, ' ')
		.split(/\s+/)
		.filter(Boolean)
		.map((token) => abbreviations[token] ?? token)
		.join(' ')
        .trim()
};
const numbers = (s) => (s.match(/\d+/g) ?? []).join(',');

export function createAddressMatcher(locations, { threshold = 0.85 } = {}) {
	const byCountry = Map.groupBy(locations, (dl) => dl.country);
	const searchers = new Map(
		[...byCountry].map(([country, items]) => [
			country,
			new Searcher(
				items.map((dl) => ({ ...dl, _key: strip(dl.addressLine, country) })),
				{ keySelector: (dl) => dl._key, threshold, useSellers: false, returnMatchData: true },
			),
		]),
	);

	return (candidate) => {
		const searcher = searchers.get(candidate.country);
		if (!searcher) return null;
		const term = strip(candidate.addressLine, candidate.country);
		if (term.length < 5) return null;
		return (
			searcher
				.search(term)
				.filter(({ item }) => item.deliveryLocationTypeId === candidate.deliveryLocationTypeId 
                && strip(item.city, candidate.country) === strip(candidate.city, candidate.country) 
                && strip(item.postcode, candidate.country) === strip(candidate.postcode, candidate.country) 
                && numbers(item._key) === numbers(term))
				.at(0)?.item ?? null
		);
	};
}